<template>
    <div class="rules-page">
        <div class="container">
            <div class="vectorImg_10"><img :src="vectorImg_10" alt=""></div>
            <div class="vectorImg_11"><img :src="vectorImg_11" alt=""></div>
            <div class="ico7"><img :src="ico_07" alt=""></div>
            <div class="ico3"><img :src="ico_03" alt=""></div>
            <div class="gorohPic"><img :src="gorohPic" alt=""></div>
            <div class="page-title">
                <h1>{{ dictionaryLang.rulesPage.title }}</h1>
            </div>
            <div class="rulse-scroll-desc">
                <vue-custom-scrollbar class="scroll-area dropdown-scroll-container" :settings="settings" ref="scrollArea">
                    <div class="rules-items">
                        <div class="item" v-for="(item, index) in dataRulesLang" :id="'rules-desc' + index">
                            <h4>{{ item.title_main }}</h4>
                            <h3 v-if="item.title != null">{{index}}. {{ item.title }}</h3>
                            <div class="title-desc-info">
                                <p v-html="item.desc" v-if="item.desc != null" class="name-part"></p>
                                <div class="desc-item" v-for="(descItem, index) in item.items">
                                    <p v-html="descItem.desc" class="desc-item-name"></p>
                                    <ul v-if="descItem.list != null" class="desc-item-list">
                                        <li v-for="listItem in descItem.list" v-html="listItem"></li>
                                    </ul>
                                    <div class="full-list" v-if="descItem.desc_list != null">
                                        <div class="full-list-item" v-for="(listItemDesc, indexDesc) in descItem.desc_list">
                                            <h5>{{ indexDesc + 1 }})<span v-html="listItemDesc.name"></span></h5>
                                            <ul >
                                                <li v-for="(item_l, index_l) in listItemDesc.list">
                                                    <p v-html="item_l"></p>
                                                </li>
                                            </ul>
                                            <span class="list-end" v-html="listItemDesc.list_ned"></span>
                                        </div>
                                    </div>
                                    <div class="item-table" v-if="descItem.desc_table != null">
                                        <table>
                                            <tr>
                                                <td>№ еженедельного розыгрыша</td>
                                                <td>Дата розыгрыша</td>
                                                <td>Период приема заявок (регистрация чеков)</td>
                                                <td>Кол-во разыгрываемых еженедельных призов (штук)</td>
                                            </tr>
                                            <tr v-for="itemTable in descItem.desc_table">
                                                <td>{{ itemTable.number }}</td>
                                                <td>{{ itemTable.date }}</td>
                                                <td>{{ itemTable.start_end }}</td>
                                                <td>{{ itemTable.count }}</td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>28</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- {{ dataRules.rulesDesc.ru }} -->
                </vue-custom-scrollbar>
            </div>
            
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import jsonData from '@/components/rules-page/rules-data.json';
    // import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'rules--page',
        components: {
            vueCustomScrollbar,
            // svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                settings: {
                    minScrollbarLength: 180,
                    maxScrollbarLength: 180,
                    suppressScrollY: false,
                    suppressScrollX: true,
                },
                dataRules: jsonData,
                dataRulesLang: jsonData,
                vectorImg_10: require('@/assets/images/svg/vector-bg-10.svg'),
                vectorImg_11: require('@/assets/images/svg/vector-bg-11.svg'),
                ico_07: require('@/assets/images/ico_7_1.png'),
                ico_03: require('@/assets/images/ico_3_1.png'),
                gorohPic: require('@/assets/images/goroh-pic.png'),
            }
        },
        computed: mapGetters({
            dictionaryLang: 'loadDictionaryLang',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            hideScroll() {
                if (this.isMobileChecker) {
                    this.settings.suppressScrollY = true
                }
            },
            scrollToRulesSix() {
                // const scrollArea = this.$refs.scrollArea;
                // const targetElement  = scrollArea.$el.querySelector('#rules-desc6');
                // if (scrollArea && targetElement) {
                //     const containerRect = scrollArea.$el.getBoundingClientRect();
                //     const targetRect = targetElement.getBoundingClientRect();
                //     const scrollTop = targetRect.top - containerRect.top + scrollArea.$el.scrollTop;
                //     // Scroll to the target element
                //     scrollArea.$el.scrollTop = scrollTop;
                // }
                if (window.location.hash === '#rules-desc6' && !this.isMobileChecker) {
                    // Scroll to the element with the ID rules-desc6 after a short delay to ensure the component is rendered
                    setTimeout(() => {
                        const scrollArea = this.$refs.scrollArea;
                        const targetElement = document.getElementById('rules-desc6');
                        if (scrollArea && targetElement) {
                            const containerRect = scrollArea.$el.getBoundingClientRect();
                            const targetRect = targetElement.getBoundingClientRect();
                            const scrollTop = targetRect.top - containerRect.top + scrollArea.$el.scrollTop;
                            // Scroll to the target element
                            scrollArea.$el.scrollTop = scrollTop;
                        }
                    }, 100); // Adjust the delay as needed
                }
            },
            setLangJson() {
                if (this.globalLang == 'ru') {
                    this.dataRulesLang = this.dataRules.rulesDesc.ru
                } else {
                    this.dataRulesLang = this.dataRules.rulesDesc.kz
                }
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'rules';
        },
        created () {
            this.setLangJson();
            this.hideScroll();
        },
        mounted() {
            // setTimeout(() => {
                this.scrollToRulesSix();
            // }, 2000);
            // console.log(this.dataRules)
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/rules-page/rules-page.scss';
    @import '@/styles/components/rules-page/rules-page-respond.scss';
</style>